import React, { Component } from 'react';

class Page extends Component {
  render() {
    return (
      <>
        <div className="static">
          <header>
            <img src={process.env.PUBLIC_URL + '/global/images/logos/usa-logo.png'} className="logo" alt="University of St. Augustine" />
          </header>
        </div>
      </>
    );
  }
}

export default Page;